import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import "./homepagecomponents.css"

const HomepageComp4 = () => {
    const { t } = useTranslation();
    const ref = useRef();
    const [isVisible, setIsVisible] = useState(false);

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.unobserve(entry.target);
            }
        });
    });

    useEffect(() => {
        const currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [ref]);

    return (
        <div className={`homepage-component-container homepage-comp4-container  ${isVisible ? 'fade-in' : ''}`} ref={ref}>

            <div className='md:grid grid-cols-2 gap-8 md:px-8'>
                <div>
                    <h1 className='homepage-title2'>
                        {t('homepage.comp4.title')}
                    </h1>
                    <p className='homepage-text3'>
                        {t('homepage.comp4.desc1')}
                    </p>
                    <p className='homepage-text3'>
                        {t('homepage.comp4.desc2')}
                    </p>
                    <ul className='homepage-text3 list-disc pl-8'>
                        <li>{t('homepage.comp4.advantages.adv1')}</li>
                        <li>{t('homepage.comp4.advantages.adv2')}</li>
                        <li>{t('homepage.comp4.advantages.adv3')}</li>
                        <li>{t('homepage.comp4.advantages.adv4')}</li>
                        <li>{t('homepage.comp4.advantages.adv5')}</li>
                    </ul>
                    {/* <p className='homepage-text3'>Join us in redefining the future of responsible mining, where every investment plays a vital role in sustainable development.</p> */}
                </div>
                <div>
                    <div className='homepage-img5'></div>
                </div>
            </div>

        </div>
    )
}

export default HomepageComp4;